export default __webpack_public_path__ + "static/media/school-backpack.3bfb4e51.png";